module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "recomment-item-foot-main"
  }, [_c('div', {
    staticClass: "recommend-item-foot",
    attrs: {
      "name": _vm.recommend.idx
    }
  }, [_c('div', {
    staticClass: "recomment-item-foot-wra"
  }, [((_vm.recommend.idx == _vm.public.classIdx.onePrice || _vm.recommend.idx == _vm.public.classIdx.chaozhi)) ? _c('div', [_vm._l((_vm.recommend.pList), function(p, index) {
    return _c('div', {
      directives: [{
        name: "first",
        rawName: "v-first.once",
        value: (index),
        expression: "index",
        modifiers: {
          "once": true
        }
      }],
      staticClass: "idxClass-body",
      on: {
        "click": function($event) {
          _vm.public.gotoDetail(p, _vm.type, 0, index)
        }
      }
    }, [_c('div', {
      staticClass: "idxClass-body-head"
    }, [_c('img', {
      attrs: {
        "src": _vm.updatePicSrc(p.Pic)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "idxClass-body-body"
    }, [_c('span', [_vm._v(_vm._s(p.sTitle ? p.sTitle : p.Title))])]), _vm._v(" "), _c('div', {
      staticClass: "idxClass-body-foot"
    }, [_c('div', {
      staticClass: "idxClass-body-foot-left"
    }, [_c('span', [_vm._v("¥" + _vm._s(p.Price))])]), _vm._v(" "), _c('div', {
      staticClass: "idxClass-body-foot-right"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("subPrice")(p.Quan_price)) + "元券")])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "more-product",
    on: {
      "click": function($event) {
        _vm.gotoRecoment()
      }
    }
  }, [_c('span', {
    staticClass: "more-product-title"
  }, [_vm._v("更多商品")]), _c('span', {
    staticClass: "more-product-point"
  }, [_vm._v(">")])])], 2) : _c('div', _vm._l((_vm.recommend.pList), function(p) {
    return _c('div', {
      staticClass: "recommend-item-foot-body",
      on: {
        "click": function($event) {
          _vm.public.gotoDetail(p, _vm.type, 0, _vm.index)
        }
      }
    }, [_c('div', {
      staticClass: "recommend-item-foot-body-head"
    }, [_c('img', {
      attrs: {
        "src": _vm.updatePicSrc(p.Pic)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "recommend-item-foot-body-foot"
    }, [_c('span', {
      staticClass: "recommend-item-foot-body-foot-price"
    }, [_vm._v("¥" + _vm._s(_vm._f("subPrice")(p.Price)))]), _c('span', {
      staticClass: "recommend-item-foot-body-foot-org"
    }, [_vm._v(" ¥" + _vm._s(_vm._f("subPrice")(p.Org_Price)))])])])
  }))])]), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-93874946","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/taoke/RecommendSwiper.vue
// module id = 211
// module chunks = 2